import { Component, OnInit, Output, EventEmitter } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastsManager } from 'ng2-toastr';
import { SubscriptionPlanDetail, SubscriptionPlanItem } from '../../models/subscriptionplan';
import { SubscriptionplanService } from '../../services/subscriptionplan.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-subscriptionplans-delete',
  templateUrl: './subscriptionplans-delete.component.html',
  styleUrls: ['./subscriptionplans-delete.component.css']
})
export class SubscriptionplansDeleteComponent implements OnInit {

  sp : SubscriptionPlanItem;
  @Output() onDeleteValidation = new EventEmitter<boolean>();
  
  constructor(private spService : SubscriptionplanService,
              public activeModal : NgbActiveModal,
              public toast : ToastsManager,
              public translate : TranslateService) { }

  ngOnInit() {
  }

  onDeleteClick() {
    this.spService.patch(this.sp).subscribe(() => {
      this.activeModal.close("close");
      this.toast.success(this.translate.instant("toast.spdeleted"), this.translate.instant("toast.success"));
      this.onDeleteValidation.emit(true);
    });
    
  }
}



// WEBPACK FOOTER //
// ./src/app/subscriptionplans/subscriptionplans-delete/subscriptionplans-delete.component.ts